export enum OrderStatus {
  Allocated = 'ORDER_ALLOCATED',
  Shipped = 'ORDER_SHIPPED',
}
